import { RECRUITERCANDIDATEPERMANENTDATA } from "../../ENVIRONMENT";

// api for recruiter permanentdata dashboard
async function recgetPermanentDataDashboard(token) {
  return await fetch(RECRUITERCANDIDATEPERMANENTDATA, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
  });
}

export { recgetPermanentDataDashboard };
